<wms-dialog-header (onClose)="closeModal()" title="{{locale.LABEL_PUBLISH_PREFAB_WORKSPACE}}"></wms-dialog-header>
<wms-dialog-body>
  <wms-spinner *ngIf="loadingData"></wms-spinner>
  <div class="studio-artifact-content" *ngIf="!loadingData">
    <wms-message type="error" *ngIf="showErrMsg" [scopeDataset]="errMsg"></wms-message>
    <div>
      <p>{{locale.MESSAGE_INFO_PUBLISH_PREFAB_WORKSPACE}}</p>
    </div>
    <div class="prefab-details col-md-12">
      <label class="col-md-3 app-label control-label">{{locale.LABEL_PREFAB_NAME}}</label>
      <label class="col-md-9 app-label control-label">{{projectDefaults.name}}</label>
    </div>
    <div class="prefab-details col-md-12">
      <label class="col-md-3 app-label control-label required">{{locale.LABEL_ARTIFACT_CATEGORY}}</label>
      <div class="col-md-9">
        <wms-typeahead name="category" [editable]="true"
        (onSelect)="setCategory($event)" (onClear)="unsetCategory()"
        [model]="publishDetails.category" [options]="categories"
        [modelType]="'string'"></wms-typeahead>
      </div>
    </div>
    <div class="prefab-details col-md-12">
      <label class="col-md-3 app-label control-label">{{locale.LABEL_VERSION_CURRENT}}</label>
      <div class="col-md-9"><label class="app-label">{{projectDefaults.version}}</label></div>
    </div>
    <div class="prefab-details col-md-12 new-version-group">
      <label class="col-md-3 app-label control-label required">{{locale.LABEL_VERSION_NEW}}</label>
      <div class="col-md-5 new-version">
        <wms-typeahead name="newVersion" [editable]="true"
                       [placeholder]="locale.PLACEHOLDER_NEW_VERSION"
                       [ngClass]="{'invalid-input': !publishDetails.isValid }"
                       (onSelect)="setNewVersion($event)" (onClear)="unsetNewVersion()"
                       [model]="publishDetails.version"  [options]="suggestedVersions"
                       propertyName="version" groupBy="category"
                       [modelType]="'string'" [updateValueOn]="'blur'"></wms-typeahead>
      </div>
      <i class="wms wms-help col-md-4" (click)="toggleTooltip()"></i>
      <div class="wms-help-panel-container" *ngIf="tooltipVisible">
        <div class="wms-help-panel">
          <div class="body" [innerHTML]="locale.MSG_HELP_SEMANTIC_VERSION"></div>
          <div class="footer">
            <a [href]="locale.SEMANTIC_VERSION_DOC_LINK" target="_blank">{{locale.USER_GUIDE}}</a> <br>
          </div>
        </div>
      </div>
    </div>
    <div class="prefab-details col-md-12">
      <label class="col-md-3 app-label control-label required">{{locale.LABEL_VCS_COMMIT}}</label>
      <div class="col-md-9">
        <textarea rows="2" class="app-textarea" name="commitMsg" [(ngModel)]="publishDetails.commitMsg" [ngModelOptions]="{updateOn: 'change'}"></textarea>
        <textarea *ngIf="showCommitMsg" rows="5" class="app-textarea readonly" [(ngModel)]="vcsCommitMsg" [readonly]="true"></textarea>
      </div>
    </div>
  </div>
</wms-dialog-body>
<wms-dialog-footer>
  <button name="cancel-prefab-publish" (click)="closeModal()" class="btn app-button button-secondary" title="{{locale.LABEL_CANCEL}}">{{locale.LABEL_CANCEL}}</button>
  <button name="wm-publish-prefab-ws" [disabled]="!publishDetails.isValid || !publishDetails.version || !publishDetails.commitMsg || !publishDetails.category" (click)="publishChangesToWorkspace()" class="btn app-button button-primary" title="{{locale.LABEL_TEMPLATE_PROPS_PUBLISH}}">{{locale.LABEL_TEMPLATE_PROPS_PUBLISH}}</button>
</wms-dialog-footer>
